export enum GeneticRiskFactor {
  FIRST_DEGREE = 'firstDegree',
  SECOND_DEGREE = 'secondDegree',
  NONE_DEGREE = 'none',
  UNKNOWN_DEGREE = 'unknown',
}

export const GeneticRiskFactorMapping = {
  [GeneticRiskFactor.FIRST_DEGREE]: $localize`:@@common_geneticRiskFactor_firstDegree:First degree`,
  [GeneticRiskFactor.SECOND_DEGREE]: $localize`:@@common_geneticRiskFactor_secondDegree:Second degree`,
  [GeneticRiskFactor.NONE_DEGREE]: $localize`:@@common_geneticRiskFactor_noneDegree:None`,
  [GeneticRiskFactor.UNKNOWN_DEGREE]: $localize`:@@common_geneticRiskFactor_unknownDegree:Unknown degree`,
};
